<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-12 router-view-report-background">
    <report-filters
      @submit-report="submitReport"
      @show-solids="showSolids"
      @hide-solids="hideSolids"
    />
    <button-export
      v-if="Object.keys(results).length"
      title="Extrato de Lactação"
      @export-pdf="PDFExport"
      :print="true"
      @print="PDFPrint"
    />
    <div style="position: relative">
      <div class="col-12 px-0 mt-2" v-if="Object.keys(results).length">
        <the-table
          :dataItems="[results.header]"
          :headers="headersForTableHeader"
        />
      </div>
      <div class="col-12 px-0 mt-2" v-if="Object.keys(results).length">
        <the-table
          :dataItems="results.services"
          :headers="headersForTableServices"
        />
      </div>
      <div class="col-12 px-0 mt-2" v-if="Object.keys(results).length">
        <h6 class="section-title">{{ results.footer.last_service.interval }} dias</h6>
        <the-table
          :dataItems="[results.footer.last_service]"
          :headers="headersForTableLastService"
        />
      </div>
      <div class="col-12 px-0 mt-2" v-if="Object.keys(results).length && showThreehoundredDays">
        <h6 class="section-title">305 dias</h6>
        <the-table
          :dataItems="[results.footer.in_305]"
          :headers="headersForTableFooter"
        />
      </div>
      <div class="col-12 px-0 mt-2" v-if="Object.keys(results).length && showYearlyComparation">
        <h6 class="section-title">365 dias</h6>
        <the-table
          :dataItems="[results.footer.in_365]"
          :headers="headersForTableFooter"
        />
      </div>
      <div class="col-12 px-0 mt-2" v-if="!Object.keys(results).length">
      <the-table
        :dataItems="[]"
        :headers="headersForTableServices"
      />
    </div>
    <div class="watter-mark" v-if="filter.manager">
      <span>NÃO OFICIAL</span>
    </div>
    </div>
  </div>
</template>

<script>
import ReportFilters from "./ReportFilters.vue";
import TheTable from "@/components/layout/TheTable.vue";
import ButtonExport from "@/components/layout/ButtonExport.vue";
import { mapActions, mapState } from 'vuex';
import mixins from "@/mixins/helpers.js";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { drawOfficialHeader, loadOfficialLogo } from "@/utils/officialPdf";
export default {
  name: "MilkExtractionReport",
  mixins:[mixins],
  components: {
    ReportFilters,
    TheTable,
    ButtonExport
  },
  data: () => ({
    headersForTableHeader: [
      { text:"Nome do animal", value:"animal" },
      { text:"Nascimento", value:"born_at" },
      { text:"Idade ao Parto", value:"age_to_birth" },
      { text:"Encerramento", value:"end_at" },
    ],
    headersForTableServices: [
      { text:"Dt Controle", value:"animal" },
      { text:"1º Ord", value:"first_weight" },
      { text:"2º Ord", value:"second_weight" },
      { text:"3º Ord", value:"third_weight" },
      { text:"Total", value:"total" },
      { text:"Gordura", value:"fat" },
      { text:"Proteína", value:"protein" },
      { text:"Lactose", value:"lactose" },
      { text:"Sólidos Totais", value:"solids" },
      { text:"Ureia", value:"urea" },
      { text:"CCS/1000", value:"ccs" },
      { text:"Intervalo", value:"interval" },
      { text:"Dias Acumulados", value:"days_acumlate" },
      { text:"Total Leite", value:"total_weight" },
      { text:"Leite Acum", value:"acumulate_weight" },
      { text:"Gord. Acum", value:"fat_acumulate" },
      { text:"Prot. Acum", value:"protein_acumulate" },
    ],
    headersForTableFooter: [
      { text:"Leite Acum", value:"milk_acumlate", style: true},
      { text:"Gord. Acum", value:"fat_acumlate", style: true},
      { text:"Prot. Acum", value:"protein_acumlate", style: true},
      { text:"Gord. Perc", value:"percent_fat", style: true},
      { text:"Prot. Perc", value:"percent_protein", style: true},
    ],
    headersForTableLastService: [
    { text: "Leite Acum", value: "total", style: true },
    { text: "Gord. Acum", value: "fat", style: true },
    { text:"Prot. Acum", value:"protein", style: true },
    { text:"Gord. Perc", value:"fat_percent", style: true },
    { text:"Prot. Perc", value:"protein_percent", style: true },
    ],
    filter:{},
    showYearlyComparation: false,
    showThreehoundredDays: false
  }),
  computed: {
    ...mapState("milk_extractions_report", [
      "results"
    ]),
  },
  methods: {
    ...mapActions("milk_extractions_report", [
      "actionGetMilkExtractions"
    ]),
    showSolids() {
      if(!this.headersForTableServices.find(e => e.value === "solids")) {
        this.headersForTableServices.splice(8, 0,  { text:"Sólidos Totais", value:"solids" });
      } else {
        return;
      }
    },
    hideSolids() {
      if(this.headersForTableServices.find(e => e.value === "solids")) {
        this.headersForTableServices.splice(8, 1);
      }
    },
    checkIfShow() {
      const allServices = [...this.results.services];
      const lastService = allServices.pop();
      if(lastService && lastService.days_acumlate) {
        if(lastService.days_acumlate >= 305) this.showThreehoundredDays = true;
        else this.showThreehoundredDays= false;
        if(lastService.days_acumlate >= 365) this.showYearlyComparation = true;
        else this.showYearlyComparation = false;
      }
    },
    async submitReport(filter) {
      this.filter = filter;
      await this.actionGetMilkExtractions({id: filter.birth.id, report_type: filter.option ? "official" : "manager"});
    },
    async PDFExport(print = false) {
      const printWindow = print ? window.open("", "_blank") : null;
      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
      const logo = await loadOfficialLogo();
      const animal = this.filter.animal_data || {};
      const header = this.results.header;
      const details = [
        `Animal: ${header.animal || "-"}    Registro: ${animal.register || "-"}    Nascimento: ${header.born_at || "-"}`,
        `Criador: ${animal.creator?.name || "-"}    Propriedade: ${animal.farm?.name || "-"}`,
        `Parto: ${header.birthday || "-"}    Idade ao parto: ${header.age_to_birth || "-"}    Encerramento: ${header.end_at || "-"}`
      ];
      const drawHeader = () => drawOfficialHeader(doc, {
        logo, title: "EXTRATO DE LACTAÇÃO", details, unofficial: !this.filter.option
      });
      const tableOptions = {
        margin: { left: 26, right: 26, top: 151, bottom: 30 },
        theme: "grid",
        styles: { font: "helvetica", fontSize: 7, cellPadding: 3, textColor: [35, 37, 48] },
        headStyles: { fillColor: [21, 11, 50], textColor: 255, fontStyle: "bold" },
        didDrawPage: drawHeader
      };
      const rows = this.results.services || [];
      const sections = [
        { title: "CONTROLES E ANÁLISES", keys: ["animal", "first_weight", "second_weight", "third_weight", "total", "fat", "protein", "lactose", "solids", "urea", "ccs", "interval"] },
        { title: "PRODUÇÃO ACUMULADA", keys: ["animal", "days_acumlate", "total_weight", "acumulate_weight", "fat_acumulate", "protein_acumulate"] }
      ];
      let startY = 161;
      sections.forEach(section => {
        const keys = section.keys.filter(key => this.headersForTableServices.some(item => item.value === key));
        if (startY > doc.internal.pageSize.getHeight() - 90) {
          doc.addPage();
          startY = 161;
        }
        doc.setTextColor(21, 11, 50);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text(section.title, 26, startY - 8);
        const columns = keys.map(key => this.headersForTableServices.find(item => item.value === key));
        doc.autoTable({
          ...tableOptions,
          startY,
          head: [columns.map(column => column.text)],
          body: rows.map(row => keys.map(key => {
            if (key === "animal" && row.virtual) return `${row.date} (${row.closing ? "encerramento" : "último trecho"})`;
            return row[key] === null || row[key] === undefined || row[key] === "" ? "-" : String(row[key]);
          }))
        });
        startY = doc.lastAutoTable.finalY + 25;
      });
      if (startY > doc.internal.pageSize.getHeight() - 110) {
        doc.addPage();
        startY = 161;
      }
      doc.setTextColor(21, 11, 50);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text("TOTAIS DA LACTAÇÃO", 26, startY - 8);
      const footer = this.results.footer;
      const total = footer.last_service;
      const totalRow = (label, days, milk, fat, protein, fatPercent, proteinPercent) =>
        [label, days, milk, fat, protein, fatPercent, proteinPercent].map(value => String(value ?? "-"));
      doc.autoTable({
        ...tableOptions,
        startY,
        head: [["Período", "Dias", "Leite (kg)", "Gordura (kg)", "Proteína (kg)", "Gordura (%)", "Proteína (%)"]],
        body: [
          totalRow("Lactação", total.interval, total.total, total.fat, total.protein, total.fat_percent, total.protein_percent),
          totalRow("305 dias", 305, footer.in_305.milk_acumlate, footer.in_305.fat_acumlate, footer.in_305.protein_acumlate, footer.in_305.percent_fat, footer.in_305.percent_protein),
          totalRow("365 dias", 365, footer.in_365.milk_acumlate, footer.in_365.fat_acumlate, footer.in_365.protein_acumlate, footer.in_365.percent_fat, footer.in_365.percent_protein)
        ]
      });
      const register = (animal.register || "animal").replace(/[^a-zA-Z0-9_-]/g, "_");
      if (print) {
        doc.autoPrint();
        if (printWindow) printWindow.location.href = doc.output("bloburl");
        else doc.save(`extrato_lactacao_${register}.pdf`);
      } else {
        doc.save(`extrato_lactacao_${register}.pdf`);
      }
    },
    async PDFPrint() {
      await this.PDFExport(true);
    }
  },
  watch: {
    results() {
      this.checkIfShow();
    }
  }
}
</script>

<style scoped>

/* marca do modo Gerencial: visível, mas sem atrapalhar a leitura dos números */
.watter-mark {
  position: absolute;
  font-size: 10rem;
  font-weight: 800;
  top: 60%;
  left: 0%;
  opacity: 0.12;
  color: #9a6c00;
  width: 100vw;
  transform: rotate(50deg);
  pointer-events: none;
  user-select: none;
}
</style>
